/**
 * Toplist V2 — View More/Less
 *
 * Scoped to each .toplist-v2 container independently.
 * Works without data-index — uses DOM order of .toplist-v2-card children.
 */
(function () {
  var CARD_CLASS = 'toplist-v2-card';
  var HIDDEN_CLASS = CARD_CLASS + '--hidden';

  document.addEventListener('DOMContentLoaded', function () {
    var buttons = document.querySelectorAll('.toplist-v2-view-more');

    buttons.forEach(function (btn) {
      var container = btn.parentElement;
      if (!container) return;

      var initial = parseInt(btn.dataset.initial, 10) || 5;
      var step = parseInt(btn.dataset.step, 10) || 5;
      var moreText = btn.dataset.moreText || btn.textContent.trim();
      var lessText = btn.dataset.lessText || 'View Less';

      function getCards() {
        return container.querySelectorAll('.' + CARD_CLASS);
      }

      function getVisibleCount() {
        var cards = getCards();
        var count = 0;
        cards.forEach(function (card) {
          if (!card.classList.contains(HIDDEN_CLASS)) count++;
        });
        return count;
      }

      function update() {
        var cards = getCards();
        var visible = getVisibleCount();
        var isFullyExpanded = visible >= cards.length;

        if (isFullyExpanded) {
          btn.textContent = lessText;
          btn.dataset.state = 'less';
          btn.setAttribute('aria-expanded', 'true');
        } else {
          btn.textContent = moreText;
          btn.dataset.state = 'more';
          btn.setAttribute('aria-expanded', 'false');
        }

        // Hide button entirely if total cards <= initial
        if (cards.length <= initial) {
          btn.style.display = 'none';
        } else {
          btn.style.display = '';
        }
      }

      btn.addEventListener('click', function () {
        var cards = getCards();
        var state = btn.dataset.state;

        if (state === 'more') {
          // Show next batch
          var shown = 0;
          cards.forEach(function (card) {
            if (shown >= step) return;
            if (card.classList.contains(HIDDEN_CLASS)) {
              card.classList.remove(HIDDEN_CLASS);
              shown++;
            }
          });
        } else {
          // Collapse back to initial
          cards.forEach(function (card, i) {
            if (i >= initial) {
              card.classList.add(HIDDEN_CLASS);
            } else {
              card.classList.remove(HIDDEN_CLASS);
            }
          });
        }

        update();
      });

      // Initial state
      update();
    });
  });
})();
